import type { addressType } from '$lib/types/util';
import { api } from './utils';

export async function postPresence(smartContractWalletAddress: addressType) {
	if (!smartContractWalletAddress) return;

	const response = await api(
		'post',
		`perps/presence/register?account=${smartContractWalletAddress}&apiKey=${'hello-world-alpha-apple-uncle-peppy-paneer'}`
	);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}
